import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const addHttpError = createAction(
  '[Http Error] Add http Error',
  props<{ payload: HttpErrorResponse }>(),
);
